{
  "title": "收件箱",
  "totalBadge": "{{count}} 项",
  "viewAll": "查看全部",
  "loading": "加载中…",
  "emptySection": "全部已处理",
  "loadError": "无法加载此部分"
}
